import { CharityVettingStatus } from 'api/users/types';
import useCharityVettingStatus from 'common/auth/useCharityVettingStatus';
import { Navigate, Outlet } from 'react-router';
import { DONATIONS_PATH, VETTING_PROGRESS_PATH } from 'src/core/paths/paths';

const RequireNotVetted = () => {
  const { isLoading, charityVettingStatus } = useCharityVettingStatus();

  if (isLoading) {
    return null;
  }
  // A vetted charity belongs in the collection app.
  if (charityVettingStatus === CharityVettingStatus.Vetted) {
    return <Navigate to={DONATIONS_PATH} replace />;
  }
  // A refused (NOT_VETTED) charity stays on the progress/refused page.
  if (charityVettingStatus === CharityVettingStatus.NotVetted) {
    return <Navigate to={VETTING_PROGRESS_PATH} replace />;
  }
  // Otherwise (no charity yet, or vetting still in progress) the user may enter
  // the wizard — an in-progress charity resumes at its first incomplete step
  // (see CharityVettingEntry).
  return <Outlet />;
};

export default RequireNotVetted;
